var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayAudioIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#282828"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0931 19.9153L17.875 14.0303V28.9934L27.0894 23.0878C27.3576 22.9192 27.5787 22.6853 27.7321 22.4081C27.8855 22.1309 27.9662 21.8194 27.9665 21.5026C27.9669 21.1857 27.887 20.874 27.7343 20.5964C27.5815 20.3189 27.361 20.0845 27.0931 19.9153Z",
    fill: "#7B7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayAudioIcon);
export default __webpack_public_path__ + "static/media/play-audio-icon.cf94705279f5afc2b6bf2c34e2a21163.svg";
export { ForwardRef as ReactComponent };